"use client";

import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@nextui-org/react";
import {useState} from "react";
import {TrendsChart} from "./charts/speed";

export const Speed: React.FC<any> = ({statistics}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onCloseDrawer = () => {
    setDrawerOpen(false);
  };
  return (
    <>
      <div className="flex h-[200px] items-stretch justify-between gap-2">
        {/* Total / Scheduled / Unscheduled */}
        <div className="flex h-full w-[40%] flex-col  gap-2 rounded-lg border border-gray-300 p-2">
          <div className="relative flex items-center justify-center">
            <div className="flex items-center gap-2">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.1875 0.875H1.8125C1.56386 0.875 1.3254 0.973772 1.14959 1.14959C0.973772 1.3254 0.875 1.56386 0.875 1.8125V11.1875C0.875 11.4361 0.973772 11.6746 1.14959 11.8504C1.3254 12.0262 1.56386 12.125 1.8125 12.125H11.1875C11.4361 12.125 11.6746 12.0262 11.8504 11.8504C12.0262 11.6746 12.125 11.4361 12.125 11.1875V1.8125C12.125 1.56386 12.0262 1.3254 11.8504 1.14959C11.6746 0.973772 11.4361 0.875 11.1875 0.875ZM10.6016 6.71445C9.82871 7.59336 9.1168 7.90332 8.47051 7.90332C7.59512 7.90332 6.84102 7.34023 6.21875 6.87559C5.09375 6.03535 4.3502 5.48047 3.10156 6.90371C3.06211 6.95362 3.01291 6.99497 2.95696 7.02525C2.90101 7.05553 2.83948 7.07411 2.77613 7.07984C2.71277 7.08558 2.6489 7.07836 2.58843 7.05863C2.52795 7.03889 2.47212 7.00705 2.42434 6.96505C2.37656 6.92304 2.33783 6.87175 2.31052 6.8143C2.2832 6.75684 2.26786 6.69443 2.26543 6.63086C2.26301 6.56729 2.27355 6.50389 2.29642 6.44452C2.31929 6.38516 2.354 6.33107 2.39844 6.28555C4.21777 4.21074 5.69961 5.31699 6.78125 6.12441C7.90625 6.96465 8.6498 7.51953 9.89844 6.09629C9.93789 6.04638 9.98709 6.00503 10.043 5.97475C10.099 5.94447 10.1605 5.92589 10.2239 5.92016C10.2872 5.91442 10.3511 5.92164 10.4116 5.94137C10.4721 5.96111 10.5279 5.99295 10.5757 6.03495C10.6234 6.07696 10.6622 6.12825 10.6895 6.1857C10.7168 6.24316 10.7321 6.30557 10.7346 6.36914C10.737 6.43271 10.7264 6.49611 10.7036 6.55548C10.6807 6.61484 10.646 6.66893 10.6016 6.71445Z"
                  fill="#349C42"
                />
              </svg>
              <span className="text-lg font-semibold text-gray-800">
                Summary
              </span>
            </div>
            <div className="absolute right-0">
              <Popover placement="top">
                <PopoverTrigger>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 0.25C8.07164 0.25 6.18657 0.821828 4.58319 1.89317C2.97982 2.96451 1.73013 4.48726 0.992179 6.26884C0.254225 8.05042 0.061142 10.0108 0.437348 11.9021C0.813554 13.7934 1.74215 15.5307 3.10571 16.8943C4.46928 18.2579 6.20656 19.1865 8.09787 19.5627C9.98919 19.9389 11.9496 19.7458 13.7312 19.0078C15.5127 18.2699 17.0355 17.0202 18.1068 15.4168C19.1782 13.8134 19.75 11.9284 19.75 10C19.7473 7.41498 18.7192 4.93661 16.8913 3.10872C15.0634 1.28084 12.585 0.25273 10 0.25ZM9.625 4.75C9.84751 4.75 10.065 4.81598 10.25 4.9396C10.435 5.06321 10.5792 5.23891 10.6644 5.44448C10.7495 5.65005 10.7718 5.87625 10.7284 6.09448C10.685 6.31271 10.5778 6.51316 10.4205 6.6705C10.2632 6.82783 10.0627 6.93498 9.84448 6.97838C9.62625 7.02179 9.40005 6.99951 9.19449 6.91436C8.98892 6.82922 8.81322 6.68502 8.6896 6.50002C8.56598 6.31501 8.5 6.0975 8.5 5.875C8.5 5.57663 8.61853 5.29048 8.82951 5.0795C9.04049 4.86853 9.32664 4.75 9.625 4.75ZM10.75 15.25C10.3522 15.25 9.97065 15.092 9.68934 14.8107C9.40804 14.5294 9.25 14.1478 9.25 13.75V10C9.05109 10 8.86033 9.92098 8.71967 9.78033C8.57902 9.63968 8.5 9.44891 8.5 9.25C8.5 9.05109 8.57902 8.86032 8.71967 8.71967C8.86033 8.57902 9.05109 8.5 9.25 8.5C9.64783 8.5 10.0294 8.65804 10.3107 8.93934C10.592 9.22064 10.75 9.60218 10.75 10V13.75C10.9489 13.75 11.1397 13.829 11.2803 13.9697C11.421 14.1103 11.5 14.3011 11.5 14.5C11.5 14.6989 11.421 14.8897 11.2803 15.0303C11.1397 15.171 10.9489 15.25 10.75 15.25Z"
                      fill="#3354F4"
                    />
                  </svg>
                </PopoverTrigger>
                <PopoverContent>
                  <div className="flex flex-col space-y-2  p-2 text-sm">
                    <p>
                      <span className="font-semibold text-red-600">
                        High Risk
                      </span>
                      <span className="text-gray-500">
                        {" "}
                        &gt; 20% of distance above{" "}
                      </span>
                      <span className="font-semibold text-red-600">
                        70 kmph
                      </span>
                    </p>
                    <p>
                      <span className="font-semibold text-yellow-500">
                        Medium Risk
                      </span>
                      <span className="text-gray-500">
                        {" "}
                        10-20% distance above{" "}
                      </span>
                      <span className="font-semibold text-blue-600">
                        70 kmph
                      </span>
                    </p>
                    <p>
                      <span className="font-semibold text-green-600">
                        Safe Driving
                      </span>
                      <span className="text-gray-500">
                        {" "}
                        &lt;10% distance above{" "}
                      </span>
                      <span className="font-semibold text-green-600">
                        70 kmph
                      </span>
                    </p>
                  </div>
                </PopoverContent>
              </Popover>
            </div>
          </div>
          <div className="flex w-full items-center justify-between gap-1">
            <div className="flex w-1/3 flex-col items-center justify-center gap-2 rounded-lg border border-gray-300 bg-red-200 p-4">
              {/* <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#0A6BC2]"> */}
              <svg
                width="43"
                height="44"
                viewBox="0 0 43 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  y="0.5"
                  width="42.1042"
                  height="43"
                  rx="21.0521"
                  fill="#FC2A3D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M21.5544 33.4883C28.4751 33.4883 34.0854 28.2302 34.0854 21.7441C34.0854 15.258 28.4751 10 21.5544 10C14.6338 10 9.02344 15.258 9.02344 21.7441C9.02344 28.2302 14.6338 33.4883 21.5544 33.4883ZM21.5544 32.1332C27.6766 32.1332 32.6396 27.4819 32.6396 21.7441C32.6396 16.0064 27.6766 11.3551 21.5544 11.3551C15.4323 11.3551 10.4693 16.0064 10.4693 21.7441C10.4693 27.4819 15.4323 32.1332 21.5544 32.1332Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M23.0982 21.5823C23.0718 21.6252 22.996 21.6077 22.989 21.5586C22.9648 21.388 22.9052 21.2189 22.8077 21.0606C22.4084 20.4124 21.5241 20.1904 20.8326 20.5646C20.141 20.9388 19.9041 21.7675 20.3033 22.4157C20.7026 23.0638 21.5869 23.2859 22.2784 22.9117L22.279 22.9122L22.1893 23.0577C22.1751 23.0809 22.1852 23.1105 22.2112 23.1216L27.6378 25.4356C28.0626 25.6168 28.4013 25.0669 28.0216 24.8127L23.1729 21.5672C23.1481 21.5506 23.1134 21.5576 23.0982 21.5823Z"
                  fill="white"
                />
                <path
                  d="M21.5511 14.066C21.9503 14.066 22.274 13.7627 22.274 13.3885C22.274 13.0143 21.9503 12.7109 21.5511 12.7109C21.1518 12.7109 20.8281 13.0143 20.8281 13.3885C20.8281 13.7627 21.1518 14.066 21.5511 14.066Z"
                  fill="white"
                />
                <path
                  d="M12.637 22.4215C13.0363 22.4215 13.3599 22.1182 13.3599 21.744C13.3599 21.3698 13.0363 21.0664 12.637 21.0664C12.2377 21.0664 11.9141 21.3698 11.9141 21.744C11.9141 22.1182 12.2377 22.4215 12.637 22.4215Z"
                  fill="white"
                />
                <path
                  d="M30.4729 22.4156C30.8722 22.4156 31.1959 22.1123 31.1959 21.7381C31.1959 21.3639 30.8722 21.0605 30.4729 21.0605C30.0737 21.0605 29.75 21.3639 29.75 21.7381C29.75 22.1123 30.0737 22.4156 30.4729 22.4156Z"
                  fill="white"
                />
              </svg>
              {/* </div> */}

              <span className="text-sm font-medium text-gray-600">
                High Risk
              </span>
              <span className="text-md font-bold text-gray-800">
                {statistics?.summary?.highRisk ?? "N/A"}
              </span>
            </div>
            <div className="flex w-1/3 flex-col items-center justify-center gap-2 rounded-lg border border-gray-300 bg-yellow-200 p-4">
              <svg
                width="42"
                height="43"
                viewBox="0 0 42 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="0.5" width="42" height="42" rx="21" fill="#FFC727" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.5 34C27.4036 34 33 28.4036 33 21.5C33 14.5964 27.4036 9 20.5 9C13.5964 9 8 14.5964 8 21.5C8 28.4036 13.5964 34 20.5 34ZM20.5 32.5577C26.607 32.5577 31.5577 27.607 31.5577 21.5C31.5577 15.393 26.607 10.4423 20.5 10.4423C14.393 10.4423 9.44231 15.393 9.44231 21.5C9.44231 27.607 14.393 32.5577 20.5 32.5577Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.1815 20.0522C20.2184 20.056 20.2404 20.0097 20.2131 19.9839C20.1968 19.9685 20.1969 19.9429 20.2132 19.9287L24.7406 16.0106C25.0942 15.7046 25.6048 16.1874 25.319 16.5576L21.6603 21.2972C21.6471 21.3142 21.6217 21.3157 21.6054 21.3004C21.5782 21.2747 21.5333 21.2991 21.5392 21.3355C21.5676 21.5138 21.5639 21.6991 21.5228 21.8836C21.3479 22.6715 20.5606 23.1463 19.7647 22.9442C18.9686 22.742 18.4652 21.9393 18.6402 21.1514C18.7993 20.4353 19.4641 19.9778 20.1815 20.0522Z"
                  fill="white"
                />
                <path
                  d="M20.5 13C20.7761 13 21 12.7761 21 12.5C21 12.2239 20.7761 12 20.5 12C20.2239 12 20 12.2239 20 12.5C20 12.7761 20.2239 13 20.5 13Z"
                  fill="white"
                />
                <path
                  d="M11.5 22C11.7761 22 12 21.7761 12 21.5C12 21.2239 11.7761 21 11.5 21C11.2239 21 11 21.2239 11 21.5C11 21.7761 11.2239 22 11.5 22Z"
                  fill="white"
                />
                <path
                  d="M29.5 22C29.7761 22 30 21.7761 30 21.5C30 21.2239 29.7761 21 29.5 21C29.2239 21 29 21.2239 29 21.5C29 21.7761 29.2239 22 29.5 22Z"
                  fill="white"
                />
              </svg>
              <span className="text-sm font-medium text-gray-600">
                Medium Risk
              </span>
              <span className="text-md font-bold text-gray-800">
                {statistics?.summary?.mediumRisk ?? "N/A"}
              </span>
            </div>
            <div className="flex w-1/3 flex-col items-center justify-center gap-2 rounded-lg border border-gray-300 bg-green-200 p-4">
              <svg
                width="42"
                height="43"
                viewBox="0 0 42 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="0.5" width="42" height="42" rx="21" fill="#349C42" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.5 34C27.4036 34 33 28.4036 33 21.5C33 14.5964 27.4036 9 20.5 9C13.5964 9 8 14.5964 8 21.5C8 28.4036 13.5964 34 20.5 34ZM20.5 32.5577C26.607 32.5577 31.5577 27.607 31.5577 21.5C31.5577 15.393 26.607 10.4423 20.5 10.4423C14.393 10.4423 9.44231 15.393 9.44231 21.5C9.44231 27.607 14.393 32.5577 20.5 32.5577Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.5659 20.4179C19.5953 20.3954 19.5795 20.3466 19.5419 20.3466C19.5195 20.3466 19.502 20.328 19.5041 20.3064L20.1019 14.349C20.1486 13.8837 20.8513 13.8837 20.898 14.349L21.4958 20.3066C21.4979 20.328 21.4805 20.3466 21.4581 20.3466C21.4207 20.3466 21.4048 20.3952 21.4341 20.4177C21.5772 20.5276 21.7018 20.6649 21.7988 20.8271C22.213 21.5199 21.9672 22.4057 21.2499 22.8057C20.5326 23.2057 19.6153 22.9683 19.2012 22.2756C18.8248 21.6459 18.9935 20.8568 19.5659 20.4179Z"
                  fill="white"
                />
                <path
                  d="M20.5 13C20.7761 13 21 12.7761 21 12.5C21 12.2239 20.7761 12 20.5 12C20.2239 12 20 12.2239 20 12.5C20 12.7761 20.2239 13 20.5 13Z"
                  fill="white"
                />
                <path
                  d="M11.5 22C11.7761 22 12 21.7761 12 21.5C12 21.2239 11.7761 21 11.5 21C11.2239 21 11 21.2239 11 21.5C11 21.7761 11.2239 22 11.5 22Z"
                  fill="white"
                />
                <path
                  d="M29.5 22C29.7761 22 30 21.7761 30 21.5C30 21.2239 29.7761 21 29.5 21C29.2239 21 29 21.2239 29 21.5C29 21.7761 29.2239 22 29.5 22Z"
                  fill="white"
                />
              </svg>

              <span className="text-sm font-medium text-gray-600">
                Safe Driving
              </span>
              <span className="text-md font-bold text-gray-800">
                {statistics?.summary?.safeDriving ?? "N/A"}
              </span>
            </div>
          </div>
        </div>

        {/* Chart */}
        <div className="flex h-full w-[30%] flex-col justify-center rounded-lg border border-gray-300 p-2">
          <div className="relative flex items-center justify-center">
            <div className="flex items-center gap-2">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_4176_14827)">
                  <path
                    d="M4.99128 5.26165L6.80943 2.80172C7.98467 1.21163 8.5723 0.416585 9.12054 0.584595C9.66879 0.752606 9.66879 1.72773 9.66879 3.67798V3.86186C9.66879 4.56527 9.66879 4.91698 9.89354 5.13759L9.90544 5.14902C10.135 5.36497 10.5011 5.36497 11.2332 5.36497C12.5507 5.36497 13.2094 5.36497 13.432 5.76453C13.4357 5.77114 13.4393 5.77781 13.4428 5.78453C13.6529 6.19028 13.2715 6.70631 12.5087 7.73837L10.6906 10.1983C9.51529 11.7884 8.92765 12.5834 8.37941 12.4154C7.83116 12.2474 7.83117 11.2723 7.8312 9.32199L7.8312 9.13818C7.83121 8.43476 7.83122 8.08305 7.60646 7.86243L7.59457 7.85101C7.36496 7.63505 6.9989 7.63505 6.26679 7.63505C4.94934 7.63505 4.29061 7.63505 4.06798 7.2355C4.0643 7.22888 4.06071 7.22221 4.05723 7.21549C3.84707 6.80975 4.22848 6.29372 4.99128 5.26165Z"
                    fill="#042DA6"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_4176_14827"
                    x="0"
                    y="0.5625"
                    width="17.5"
                    height="19.875"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_4176_14827"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_4176_14827"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <span className="text-lg font-semibold text-gray-800">
                Trends
              </span>
            </div>
            <div className="absolute right-0">
              <Popover placement="top">
                <PopoverTrigger>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 0.25C8.07164 0.25 6.18657 0.821828 4.58319 1.89317C2.97982 2.96451 1.73013 4.48726 0.992179 6.26884C0.254225 8.05042 0.061142 10.0108 0.437348 11.9021C0.813554 13.7934 1.74215 15.5307 3.10571 16.8943C4.46928 18.2579 6.20656 19.1865 8.09787 19.5627C9.98919 19.9389 11.9496 19.7458 13.7312 19.0078C15.5127 18.2699 17.0355 17.0202 18.1068 15.4168C19.1782 13.8134 19.75 11.9284 19.75 10C19.7473 7.41498 18.7192 4.93661 16.8913 3.10872C15.0634 1.28084 12.585 0.25273 10 0.25ZM9.625 4.75C9.84751 4.75 10.065 4.81598 10.25 4.9396C10.435 5.06321 10.5792 5.23891 10.6644 5.44448C10.7495 5.65005 10.7718 5.87625 10.7284 6.09448C10.685 6.31271 10.5778 6.51316 10.4205 6.6705C10.2632 6.82783 10.0627 6.93498 9.84448 6.97838C9.62625 7.02179 9.40005 6.99951 9.19449 6.91436C8.98892 6.82922 8.81322 6.68502 8.6896 6.50002C8.56598 6.31501 8.5 6.0975 8.5 5.875C8.5 5.57663 8.61853 5.29048 8.82951 5.0795C9.04049 4.86853 9.32664 4.75 9.625 4.75ZM10.75 15.25C10.3522 15.25 9.97065 15.092 9.68934 14.8107C9.40804 14.5294 9.25 14.1478 9.25 13.75V10C9.05109 10 8.86033 9.92098 8.71967 9.78033C8.57902 9.63968 8.5 9.44891 8.5 9.25C8.5 9.05109 8.57902 8.86032 8.71967 8.71967C8.86033 8.57902 9.05109 8.5 9.25 8.5C9.64783 8.5 10.0294 8.65804 10.3107 8.93934C10.592 9.22064 10.75 9.60218 10.75 10V13.75C10.9489 13.75 11.1397 13.829 11.2803 13.9697C11.421 14.1103 11.5 14.3011 11.5 14.5C11.5 14.6989 11.421 14.8897 11.2803 15.0303C11.1397 15.171 10.9489 15.25 10.75 15.25Z"
                      fill="#3354F4"
                    />
                  </svg>
                </PopoverTrigger>
                <PopoverContent>
                  <div className="flex flex-col space-y-2  p-2 text-sm">
                    <div className="flex items-center gap-1">
                      <span className="h-2 w-2 rounded-full bg-green-600"></span>
                      <span className="text-xs">Normal Speed</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="h-2 w-2 rounded-full bg-yellow-500"></span>
                      <span className="text-xs">Medium Speed</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="h-2 w-2 rounded-full bg-red-500"></span>
                      <span className="text-xs">High Speed</span>
                    </div>
                  </div>
                </PopoverContent>
              </Popover>
            </div>
          </div>
          <div className="flex w-full ">
            <TrendsChart statistics={statistics} />
          </div>
        </div>

        {/* Insights */}
        <div className="flex h-full w-[30%] flex-col items-center gap-6 rounded-lg border border-gray-300 p-2">
          <div className="flex w-full items-center justify-between">
            <div></div>
            <div className="flex items-center gap-1">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.0001 15.3184C11.0001 15.451 10.9474 15.5781 10.8536 15.6719C10.7599 15.7657 10.6327 15.8184 10.5001 15.8184H5.50008C5.36747 15.8184 5.2403 15.7657 5.14653 15.6719C5.05276 15.5781 5.00008 15.451 5.00008 15.3184C5.00008 15.1857 5.05276 15.0586 5.14653 14.9648C5.2403 14.871 5.36747 14.8184 5.50008 14.8184H10.5001C10.6327 14.8184 10.7599 14.871 10.8536 14.9648C10.9474 15.0586 11.0001 15.1857 11.0001 15.3184ZM13.5001 7.31835C13.5022 8.15188 13.3139 8.97488 12.9496 9.72455C12.5852 10.4742 12.0543 11.1307 11.3976 11.644C11.2748 11.7381 11.1751 11.8591 11.1062 11.9976C11.0373 12.1362 11.001 12.2886 11.0001 12.4434V12.8184C11.0001 13.0836 10.8947 13.3379 10.7072 13.5255C10.5197 13.713 10.2653 13.8184 10.0001 13.8184H6.00008C5.73487 13.8184 5.48051 13.713 5.29298 13.5255C5.10544 13.3379 5.00008 13.0836 5.00008 12.8184V12.4434C4.99998 12.2905 4.96483 12.1397 4.89733 12.0025C4.82983 11.8653 4.73177 11.7455 4.61071 11.6521C3.95558 11.1419 3.42511 10.4893 3.05944 9.7438C2.69378 8.99828 2.5025 8.17934 2.50008 7.34898C2.48383 4.37023 4.89133 1.8896 7.86758 1.81835C8.60092 1.80068 9.33039 1.92989 10.0131 2.19836C10.6957 2.46684 11.3178 2.86917 11.8426 3.38166C12.3674 3.89415 12.7845 4.50646 13.0691 5.18253C13.3538 5.85861 13.5003 6.5848 13.5001 7.31835ZM10.3538 7.4646C10.3074 7.41812 10.2523 7.38124 10.1916 7.35607C10.1309 7.33091 10.0658 7.31796 10.0001 7.31796C9.93437 7.31796 9.86931 7.33091 9.80861 7.35607C9.74791 7.38124 9.69277 7.41812 9.64633 7.4646L8.00008 9.11148L6.35383 7.4646C6.26001 7.37078 6.13276 7.31808 6.00008 7.31808C5.8674 7.31808 5.74015 7.37078 5.64633 7.4646C5.55251 7.55842 5.4998 7.68567 5.4998 7.81835C5.4998 7.95104 5.55251 8.07828 5.64633 8.1721L7.50008 10.0252V12.3184C7.50008 12.451 7.55276 12.5781 7.64653 12.6719C7.7403 12.7657 7.86747 12.8184 8.00008 12.8184C8.13269 12.8184 8.25987 12.7657 8.35364 12.6719C8.4474 12.5781 8.50008 12.451 8.50008 12.3184V10.0252L10.3538 8.1721C10.4003 8.12567 10.4372 8.07052 10.4624 8.00982C10.4875 7.94913 10.5005 7.88406 10.5005 7.81835C10.5005 7.75265 10.4875 7.68758 10.4624 7.62688C10.4372 7.56618 10.4003 7.51104 10.3538 7.4646Z"
                  fill="#FFC727"
                />
              </svg>
              <span className="text-lg font-semibold text-gray-800">
                Insights
              </span>
            </div>
            <button
              onClick={() => {
                setDrawerOpen(true);
              }}
              className="items-end rounded-lg bg-white p-1 text-sm font-medium text-blue-600 hover:bg-gray-100 hover:underline"
            >
              view all
            </button>
          </div>
          <div className="ml-2 flex w-full flex-col gap-1 overflow-auto">
            {statistics?.speedReportInsights ? (
              statistics?.speedReportInsights?.map((item: any) => (
                <div
                  key={item.title}
                  className="flex flex-col gap-2 rounded-lg"
                >
                  <span className="text-md font-bold text-black">
                    {item.title}
                  </span>
                  <span className="text-sm font-medium text-gray-600">
                    {item.content}
                  </span>
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center  text-center text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mb-4 h-16 w-16 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.75 9.75h.008v.008H9.75V9.75zm0 3.5h.008v.008H9.75v-.008zm3.5-3.5h.008v.008H13.25V9.75zm0 3.5h.008v.008H13.25v-.008zM3 8.25a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 8.25v7.5A2.25 2.25 0 0118.75 18H5.25A2.25 2.25 0 013 15.75v-7.5z"
                  />
                </svg>
                <p className="text-lg font-semibold">No Data Found</p>
                <p className="text-sm text-gray-400">
                  Please try adjusting your filters or check back later.
                </p>
              </div>
            )}
          </div>
          {/* <div className="ml-2 flex w-full flex-col gap-1">
          <div className="flex items-center justify-center gap-2 rounded-lg border border-gray-300  p-1">
            <Link
              href="/top-used-vehicles"
              className="text-sm no-underline hover:underline"
            >
              Top Used Vehicles
            </Link>
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-black text-white">
              5
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 rounded-lg border border-gray-300  p-1">
            <Link
              href="/top-used-vehicles"
              className="text-sm no-underline hover:underline"
            >
              Last Used Vehicles. Last Used Date On .Its Based on Last Used Date
            </Link>
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-black text-white">
              5
            </span>
          </div>
        </div> */}
        </div>
        <CustomDrawer
          isOpen={drawerOpen}
          size={"sm"}
          onClose={onCloseDrawer}
          statistics={statistics}
        />
      </div>
    </>
  );
};

const CustomDrawer = ({
  isOpen,
  size,
  onClose,
  statistics
}: {
  isOpen: boolean;
  size: string;
  onClose: () => void;
  statistics: any;
}) => {
  return (
    <Drawer isOpen={isOpen} size={"sm"} onClose={onClose}>
      <DrawerContent>
        {onClose => (
          <>
            <DrawerHeader className="flex flex-col gap-1">
              <div className="flex items-center gap-1">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.0001 15.3184C11.0001 15.451 10.9474 15.5781 10.8536 15.6719C10.7599 15.7657 10.6327 15.8184 10.5001 15.8184H5.50008C5.36747 15.8184 5.2403 15.7657 5.14653 15.6719C5.05276 15.5781 5.00008 15.451 5.00008 15.3184C5.00008 15.1857 5.05276 15.0586 5.14653 14.9648C5.2403 14.871 5.36747 14.8184 5.50008 14.8184H10.5001C10.6327 14.8184 10.7599 14.871 10.8536 14.9648C10.9474 15.0586 11.0001 15.1857 11.0001 15.3184ZM13.5001 7.31835C13.5022 8.15188 13.3139 8.97488 12.9496 9.72455C12.5852 10.4742 12.0543 11.1307 11.3976 11.644C11.2748 11.7381 11.1751 11.8591 11.1062 11.9976C11.0373 12.1362 11.001 12.2886 11.0001 12.4434V12.8184C11.0001 13.0836 10.8947 13.3379 10.7072 13.5255C10.5197 13.713 10.2653 13.8184 10.0001 13.8184H6.00008C5.73487 13.8184 5.48051 13.713 5.29298 13.5255C5.10544 13.3379 5.00008 13.0836 5.00008 12.8184V12.4434C4.99998 12.2905 4.96483 12.1397 4.89733 12.0025C4.82983 11.8653 4.73177 11.7455 4.61071 11.6521C3.95558 11.1419 3.42511 10.4893 3.05944 9.7438C2.69378 8.99828 2.5025 8.17934 2.50008 7.34898C2.48383 4.37023 4.89133 1.8896 7.86758 1.81835C8.60092 1.80068 9.33039 1.92989 10.0131 2.19836C10.6957 2.46684 11.3178 2.86917 11.8426 3.38166C12.3674 3.89415 12.7845 4.50646 13.0691 5.18253C13.3538 5.85861 13.5003 6.5848 13.5001 7.31835ZM10.3538 7.4646C10.3074 7.41812 10.2523 7.38124 10.1916 7.35607C10.1309 7.33091 10.0658 7.31796 10.0001 7.31796C9.93437 7.31796 9.86931 7.33091 9.80861 7.35607C9.74791 7.38124 9.69277 7.41812 9.64633 7.4646L8.00008 9.11148L6.35383 7.4646C6.26001 7.37078 6.13276 7.31808 6.00008 7.31808C5.8674 7.31808 5.74015 7.37078 5.64633 7.4646C5.55251 7.55842 5.4998 7.68567 5.4998 7.81835C5.4998 7.95104 5.55251 8.07828 5.64633 8.1721L7.50008 10.0252V12.3184C7.50008 12.451 7.55276 12.5781 7.64653 12.6719C7.7403 12.7657 7.86747 12.8184 8.00008 12.8184C8.13269 12.8184 8.25987 12.7657 8.35364 12.6719C8.4474 12.5781 8.50008 12.451 8.50008 12.3184V10.0252L10.3538 8.1721C10.4003 8.12567 10.4372 8.07052 10.4624 8.00982C10.4875 7.94913 10.5005 7.88406 10.5005 7.81835C10.5005 7.75265 10.4875 7.68758 10.4624 7.62688C10.4372 7.56618 10.4003 7.51104 10.3538 7.4646Z"
                    fill="#FFC727"
                  />
                </svg>
                <span className="text-lg font-semibold text-gray-800">
                  Insights
                </span>
              </div>
            </DrawerHeader>
            <DrawerBody>
              {statistics?.speedReportInsights ? (
                statistics?.speedReportInsights?.map((item: any) => (
                  <div
                    key={item.title}
                    className="flex flex-col gap-2 rounded-lg"
                  >
                    <span className="text-md font-bold text-black">
                      {item.title}
                    </span>
                    <span className="text-sm font-medium text-gray-600">
                      {item.content}
                    </span>
                  </div>
                ))
              ) : (
                <div className="flex flex-col items-center justify-center  text-center text-gray-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mb-4 h-16 w-16 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.75 9.75h.008v.008H9.75V9.75zm0 3.5h.008v.008H9.75v-.008zm3.5-3.5h.008v.008H13.25V9.75zm0 3.5h.008v.008H13.25v-.008zM3 8.25a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 8.25v7.5A2.25 2.25 0 0118.75 18H5.25A2.25 2.25 0 013 15.75v-7.5z"
                    />
                  </svg>
                  <p className="text-lg font-semibold">No Data Found</p>
                  <p className="text-sm text-gray-400">
                    Please try adjusting your filters or check back later.
                  </p>
                </div>
              )}
            </DrawerBody>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
};
